<template>
  <div id="logincontainer">
      <div class="form-box">
      <div class="form">
        <div v-if="errors.has('email')" class="submittooltip" v-text="errors.first('email')"></div>
        <div v-else-if="errors.has('password')" class="submittooltip" v-text="errors.first('password')"></div>
        <div v-else-if="errors.has('identifycode')" class="submittooltip" v-text="errors.first('identifycode')"></div>
        <div v-else-if="!identifycodeIsPassed" class="submittooltip" v-text="tipmessage"></div>
        <div class="form-bd">
          <ul>
            <li class="inp"><input id="email" name="email" type="text"  :placeholder="$t('messages.login_email')" v-model="email"  v-validate="'required|email'" :class="{'is-danger': errors.has('email') }"></li>
            <!-- <li class="inp"><input id="password" name="password" type="password"  placeholder="账号密码" v-model="password" v-validate="{rules: {regex:/(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/}}" :class="{'is-danger': errors.has('password') }"></li> -->
            <li class="inp"><input id="password" name="password" type="password"  :placeholder="$t('messages.login_password')" v-model="password" v-validate="'required|min:3'" :class="{'is-danger': errors.has('password') }"></li>
            <li class="inp">
              <div class="identifycode l" >
                <input id="identifycode" name="identifycode" maxlength="6" type="text" :placeholder="$t('messages.login_identifyCode')"  v-model="identifycode" v-validate="'required'" :class="{'is-danger': errors.has('identifycode'), 'ispassed':identifycodeIsPassed }">
              </div>
              <div class="identifycodeimg l" >
                <img id="registerCaptcha" @click="changeCaptcha" src="/api/refreshCaptcha" />
              </div>
            </li>
            <li class="oth">
              <div class="forg">
                <router-link to="/findpass">忘记密码</router-link>
              </div>
            </li>
            <li>
              <a id="submit" href="javascript:void(0);" class="submit" @click="login">{{$t('messages.login_login')}}</a>
            </li>
          </ul>
        </div>
		  </div>
      </div>
		</div>
</template>

<script>
import Vue from 'vue';
import {mapState,mapMutations} from 'vuex';
import VeeValidate, {Validator} from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN'

// Validator.addLocale(zh_CN);

var config = {
    errorBagName: 'errors',
    fieldsBagName: 'veeFields',
    delay: 0,
    locale: localStorage.getItem('lang'),
    messages: null,
    strict: true
}

Vue.use(VeeValidate,config)


export default {
  name: 'login',
  data () {
    return {
      email: '',
			password: '',
      identifycode: '',
      identifycodeIsPassed: false,
			tipmessage: '',
			verifyCaptchaFlag: false
    }
  },
  methods: {
		login: function() {
      // this.$store.state.email = this.email
      this.$store.commit('setEmail',this.email);
      window.localStorage.setItem('email',this.email);

      document.cookie = "email="+ this.email;

			var postdata = 'username='+this.email+'&password='+this.password+'&captcha='+this.identifycode
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.$axios.post('/mauth',postdata)
          .then(() => {
            this.$axios.get('/api/userAdmin/adminUser')
            .then((res) => {
              if(res.data.resultCode == 0) {
                var role = res.data.userAdmin.authorities;
                switch (role) {
                  case 'ROLE_ADMIN':
                    this.$router.push('/userAdmin');
                    break;
                  case 'ROLE_OPERA':
                    this.$router.push('/customerAdmin');
                    break;
                  case 'ROLE_AUDIT':
                    this.$router.push('/auditingAdmin');
                    break;
                  case 'ROLE_AUDITF':
                    this.$router.push('/auditingFAdmin');
                    break;
                  case 'ROLE_CUSSER':
                    this.$router.push('/customerServiceAdmin');
                    break;
                  default:
                    break;
                }
              }
            })


            this.identifycodeIsPassed = false;
            // return null;
          })
          .catch((error) => {
            this.$message.error('登录失败，请确认账号和密码是否正确！');
            this.changeCaptcha();
            this.identifycodeIsPassed = false;
          })
        }
      })

		},
		changeCaptcha: function() {
			var img = document.getElementById('registerCaptcha')
			img.src = '/api/refreshCaptcha?rnd=' + Math.random()
    },
    ...mapMutations(['setEmail'])
  },
  computed: {

  },
  watch: {
    identifycode: function(newValue, oldValue) {
			this.errors.remove('identifycode');
			this.identifycodeIsPassed = false;
			this.verifyCaptchaFlag = false;
			if(newValue.length != 6) {
				this.errors.add('identifycode',this.$t('messages.login_idenCodeTip'))
			} else {
				this.$axios.get('/api/verifyCaptcha?captcha='+ newValue)
				.then((res) => {
					this.verifyCaptchaFlag = true;
					if(res.data.resultCode == 0) {
						this.identifycodeIsPassed = true;
					} else {
						this.identifycodeIsPassed = false;
						this.errors.add('identifycode',this.$t('messages.login_idenCodeTip'));
					}

				});

			}
		}
  },
  mounted(){
    var lang = localStorage.getItem('lang') || 'zh-CN';
    localStorage.setItem('lang',lang);
    this.$i18n.locale = lang;
    var input = this.$t('messages.login_input')
    var passAndRepass = this.$t('messages.login_passAndRepass')
    var passTip = this.$t('messages.login_passTip')
    var dictionary = {
      zh_CN: {
          attributes: {
            email: this.$t('messages.login_mail'),
            password: this.$t('messages.login_pass'),
            repassword: this.$t('messages.login_repass'),
            identifycode: this.$t('messages.login_idenCode'),
            oldpassword: this.$t('messages.login_oldPass'),
            resetCode: this.$t('messages.login_resetCode'),
          },
          messages: {
            confirmed: function() {
              return passAndRepass
            } ,
            required: function(field,args) {
              return input+ field
            },
            regex: function () {
              return passTip
            }
          }
        }
    }

      VeeValidate.Validator.updateDictionary(dictionary);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#logincontainer { padding-top:150px;background-color: #EEF2FA; font-family: "Microsoft Yahei"; width:100%;height:100%}
#logincontainer .form-box {background-color:#F6F6F6;width:550px;height:390px;margin:10px auto 0;border: 1px solid #19478A; padding: 7px; }
#logincontainer .form { border:1px solid #C6C6C6;border-radius:5px;background-color: #EEE;  width: 530px; height:370px; margin: 0 auto;}
#logincontainer .form .submittooltip{position:absolute;top:50px;left:40px;color:#3399FF;font-size:14px;}
#logincontainer .form-bd { margin: 0px 40px; padding: 85px 0 40px 0; }
#logincontainer .form-bd .inp { padding: 3px 5px; background-color: #fff; margin-bottom: 15px; height:40px;border:1px solid #FFF;border-radius: 3px;}
#logincontainer .form-bd .inp span { font-family: "Microsoft Yahei"; font-size: 14px; color: #8b8b8b; position: absolute; top: 15px; left: 15px; cursor: text; }
#logincontainer .form-bd .inp .identifycode { width:75%; }
#logincontainer .form-bd .inp .identifycodeimg { width:20%;height:36px;line-height:36px; }
#logincontainer .form-bd .inp .identifycodeimg img{ width:96px;height:34px;cursor:pointer;}
#logincontainer .form-bd .inp2 { margin-bottom: 1px; }
#logincontainer .form-bd input { width: 100%; padding: 8px; border: none;}
#logincontainer .form-bd .oth { padding-top: 15px; }
#logincontainer .form-bd .forg { font-size: 14px; position: absolute; top: 3px; right: 0; }
#logincontainer .form-bd .forg a { color: #8e8e8e; }
#logincontainer .form-bd .forg a:hover { text-decoration: underline; }
#logincontainer .form-bd .submit { letter-spacing: 5px;border:1px solid #3399FF; border-radius: 3px ;display: block; margin: 25px 0 15px; background-color: #3399FF; font-size: 16px; font-weight:bold; color: #fff; line-height: 40px; height: 40px; text-align: center; -webkit-transition: 0.2s; -moz-transition: 0.2s; -ms-transition: 0.2s; transition: 0.2s; }
#logincontainer .form-bd .submit:hover { -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=80)"; filter: alpha(opacity=80); opacity: 0.8; }
#logincontainer .form-bd .meta { color: #8e8e8e; font-size: 14px; }
#logincontainer .form-bd .meta a { color: #ddd; }
#logincontainer .form-bd .meta a:hover { text-decoration: underline; }

.is-danger {background:#FDD; }
.ispassed {background:#dff0d8;}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue